import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { PricingPlan } from "@/model/interface/PricingPlan";
import React from "react";
import RateField from "./RateField";

interface PlanTelephonyRatesSectionProps {
  editing: Partial<PricingPlan>;
  onField: (field: string, value: unknown) => void;
}

export default function PlanTelephonyRatesSection({ editing, onField }: PlanTelephonyRatesSectionProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Telephony rates</CardTitle>
        <CardDescription>
          Per-minute call and per-message SMS rates, plus phone number monthly charge.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <RateField
          label="Outbound Calls (per minute)"
          baseRate={editing.outboundCallBaseRate ?? 0}
          markupType={editing.outboundCallMarkupType ?? "PERCENTAGE"}
          markupAmount={editing.outboundCallMarkupAmount ?? 0}
          onBaseRateChange={(newBaseRate) => onField("outboundCallBaseRate", newBaseRate)}
          onMarkupTypeChange={(newMarkupType) => onField("outboundCallMarkupType", newMarkupType)}
          onMarkupAmountChange={(newMarkupAmount) => onField("outboundCallMarkupAmount", newMarkupAmount)}
        />
        <RateField
          label="Inbound Calls (per minute)"
          baseRate={editing.inboundCallBaseRate ?? 0}
          markupType={editing.inboundCallMarkupType ?? "PERCENTAGE"}
          markupAmount={editing.inboundCallMarkupAmount ?? 0}
          onBaseRateChange={(newBaseRate) => onField("inboundCallBaseRate", newBaseRate)}
          onMarkupTypeChange={(newMarkupType) => onField("inboundCallMarkupType", newMarkupType)}
          onMarkupAmountChange={(newMarkupAmount) => onField("inboundCallMarkupAmount", newMarkupAmount)}
        />
        <RateField
          label="Outbound SMS (per message)"
          baseRate={editing.outboundSmsBaseRate ?? 0}
          markupType={editing.outboundSmsMarkupType ?? "PERCENTAGE"}
          markupAmount={editing.outboundSmsMarkupAmount ?? 0}
          onBaseRateChange={(newBaseRate) => onField("outboundSmsBaseRate", newBaseRate)}
          onMarkupTypeChange={(newMarkupType) => onField("outboundSmsMarkupType", newMarkupType)}
          onMarkupAmountChange={(newMarkupAmount) => onField("outboundSmsMarkupAmount", newMarkupAmount)}
        />
        <RateField
          label="Inbound SMS (per message)"
          baseRate={editing.inboundSmsBaseRate ?? 0}
          markupType={editing.inboundSmsMarkupType ?? "PERCENTAGE"}
          markupAmount={editing.inboundSmsMarkupAmount ?? 0}
          onBaseRateChange={(newBaseRate) => onField("inboundSmsBaseRate", newBaseRate)}
          onMarkupTypeChange={(newMarkupType) => onField("inboundSmsMarkupType", newMarkupType)}
          onMarkupAmountChange={(newMarkupAmount) => onField("inboundSmsMarkupAmount", newMarkupAmount)}
        />
        <RateField
          label="Phone Number (monthly)"
          baseRate={editing.phoneNumberBaseMonthlyRate ?? 0}
          markupType={editing.phoneNumberMarkupType ?? "PERCENTAGE"}
          markupAmount={editing.phoneNumberMarkupAmount ?? 0}
          onBaseRateChange={(newBaseRate) => onField("phoneNumberBaseMonthlyRate", newBaseRate)}
          onMarkupTypeChange={(newMarkupType) => onField("phoneNumberMarkupType", newMarkupType)}
          onMarkupAmountChange={(newMarkupAmount) => onField("phoneNumberMarkupAmount", newMarkupAmount)}
        />
        <RateField
          label="Toll-Free Number (monthly, shares the phone number markup)"
          baseRate={editing.tollfreeNumberBaseMonthlyRate ?? 0}
          markupType={editing.phoneNumberMarkupType ?? "PERCENTAGE"}
          markupAmount={editing.phoneNumberMarkupAmount ?? 0}
          onBaseRateChange={(newBaseRate) => onField("tollfreeNumberBaseMonthlyRate", newBaseRate)}
          onMarkupTypeChange={(newMarkupType) => onField("phoneNumberMarkupType", newMarkupType)}
          onMarkupAmountChange={(newMarkupAmount) => onField("phoneNumberMarkupAmount", newMarkupAmount)}
        />
        <RateField
          label="Call Recording Storage (per stored minute, monthly)"
          baseRate={editing.recordingStorageBaseRate ?? 0}
          markupType={editing.recordingStorageMarkupType ?? "FLAT"}
          markupAmount={editing.recordingStorageMarkupAmount ?? 0}
          onBaseRateChange={(newBaseRate) => onField("recordingStorageBaseRate", newBaseRate)}
          onMarkupTypeChange={(newMarkupType) => onField("recordingStorageMarkupType", newMarkupType)}
          onMarkupAmountChange={(newMarkupAmount) => onField("recordingStorageMarkupAmount", newMarkupAmount)}
        />
        <RateField
          label="Voicemail Detection (per detected call)"
          baseRate={editing.machineDetectionBaseRate ?? 0}
          markupType={editing.machineDetectionMarkupType ?? "FLAT"}
          markupAmount={editing.machineDetectionMarkupAmount ?? 0}
          onBaseRateChange={(newBaseRate) => onField("machineDetectionBaseRate", newBaseRate)}
          onMarkupTypeChange={(newMarkupType) => onField("machineDetectionMarkupType", newMarkupType)}
          onMarkupAmountChange={(newMarkupAmount) => onField("machineDetectionMarkupAmount", newMarkupAmount)}
        />
        <RateField
          label="Transcription, Deepgram (per transcribed minute)"
          baseRate={editing.deepgramTranscriptionBaseRate ?? 0}
          markupType={editing.deepgramTranscriptionMarkupType ?? "FLAT"}
          markupAmount={editing.deepgramTranscriptionMarkupAmount ?? 0}
          onBaseRateChange={(newBaseRate) => onField("deepgramTranscriptionBaseRate", newBaseRate)}
          onMarkupTypeChange={(newMarkupType) => onField("deepgramTranscriptionMarkupType", newMarkupType)}
          onMarkupAmountChange={(newMarkupAmount) => onField("deepgramTranscriptionMarkupAmount", newMarkupAmount)}
        />
      </CardContent>
    </Card>
  );
}
